import { combineReducers } from 'redux'
import locationReducer from './location'
import modalReducer from './modal'
import drawerReducer from './drawer'
import userReducer from './user'
import localesReducer from './locales'
import loadingReducer from './loader'
import navBarReducer from './navbar'
import tableFilterReducer from './tableFilters'
import searchTermReducer from './searchTerm'
import stringsReducer from './strings'
// import studiesReducer from '../routes/Studies/StudiesPage/modules/Studies'
// import studyReducer from '../routes/Studies/routes/CreateStudy/modules/CreateStudy'
import { errorReducer } from '../layouts/ErrorBox'

export const makeRootReducer = asyncReducers => {
  const combinedReducer = combineReducers({
    ...asyncReducers,
    // studies: studiesReducer,
    // study: studyReducer,
    drawer: drawerReducer,
    errorBox: errorReducer,
    loading: loadingReducer,
    locales: localesReducer,
    location: locationReducer,
    modal: modalReducer,
    navBar: navBarReducer.navProps,
    searchTerm: searchTermReducer,
    strings: stringsReducer,
    subroute: navBarReducer.subroute,
    tableFilters: tableFilterReducer,
    user: userReducer,
  })

  const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGGED_OUT') {
      // return initial state for all reducers
      state = undefined
    }

    return combinedReducer(state, action)
  }

  return rootReducer
}

export const injectReducer = (store, { key, reducer }) => {
  if (Object.hasOwnProperty.call(store.asyncReducers, key)) return

  store.asyncReducers[key] = reducer
  store.replaceReducer(makeRootReducer(store.asyncReducers))
}

export const injectReducers = (store, reducers) => {
  Object.keys(reducers).forEach(key => {
    injectReducer(store, { key, reducer: reducers[key] })
  })
}

export default makeRootReducer
